import { useFormContext } from "react-hook-form";



import NumberInput from "@/components/form-controls/NumberInput";
import RichTextEditor from "@/components/form-controls/RichTextEditor";
import SelectInput from "@/components/form-controls/SelectInput";



export default function LandConstractionsForm() {
    const { register, formState: { errors }, clearErrors,watch } = useFormContext()

    const handleInputBlur = (fieldName: string) => {
        if (errors[fieldName]) {
            clearErrors(fieldName);
        }
    }


    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">Land and Construction</h1>
            <p className="text-xs text-[#041528]">Specify the land requirements, construction plans, and timeline for your project.</p>
            <div className="mt-5 grid grid-cols-1 gap-3 w-full">
    
                 <NumberInput
                    label="Size of Land Required (in hectares)"
                    placeholder="Enter land size in hectares"
                    onBlur={() => handleInputBlur("landSizeHectares")}
                    error={errors.landSizeHectares?.message?.toString()}
                    register={register("landSizeHectares", {
                        required: "Land size is required",
                    })}
                    className="col-span-2 relative"
                    required
                />

               
                <SelectInput 
                    label="Will existing buildings be used?"
                    displayName="label"
                    valueName="value"
                    options={[
                        {
                            label: "Yes",
                            value: "yes"
                        },
                        {
                            label: "No",
                            value: "no"
                        }
                    ]}
                    register={register("existingBuildings",
                        { required: "Existing buildings is required" }
                    )}
                    required
                    className="col-span-2"
                />

                <div className="col-span-2">
                    <div className="flex items-center w-full text-sm gap-3 ">
                        {
                            watch("existingBuildings") === "no" && (
                            <SelectInput 
                                label="Construction completion time."
                                displayName="label"
                                valueName="value"
                                options={[
                                    {
                                        label: "Within 6 months",
                                        value: "6months"
                                    },
                                    {
                                        label: "Within 1 year",
                                        value: "1year"
                                    },
                                    {
                                        label: "Within 2 years",
                                        value: "2years"
                                    }
                                ]}
                                register={register("constructionCompletionTime",
                                    { required: "Construction completion time is required" }
                                )}
                                required
                                className="w-full"
                            />
                            )
                        }
                       

                        <SelectInput 
                            label="Project Lifespan"
                            displayName="label"
                            valueName="value"
                            options={[
                                {
                                    label: "Within 6 months",
                                    value: "6months"
                                },
                                {
                                    label: "Within 1 year",
                                    value: "1year"
                                },
                                {
                                    label: "Within 2 years",
                                    value: "2years"
                                }
                            ]}
                            register={register("projectLifespan",
                                { required: "Project Lifespan is required" }
                            )}
                            required
                            className="w-full"
                        />

                    </div>
                </div>
         

                <div className="flex items-center w-full text-sm gap-3 col-span-2">
                    <span className="text-nowrap text-black font-semibold">Environmental Management</span>
                    <span className="border border-[#E3E7E8] w-full h-[0.5px]"/>
                </div>
                
                <RichTextEditor
                    name="environmentalManagementPlanDescription"                       
                    placeholder="Type here..."
                    label="Describe your environmental management plan"
                    className="col-span-2"
                />
             
            </div>
        </div>
    )
}